import { IProgrammableTag, IProgrammableTagState } from './types';
import { API_CALLS } from '../../utilities/constants';
import { toast } from 'react-toastify';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IProgrammableTagState = {
  programmableTags: [],
  appliedTagsCount: null,
  apiCallsInProgress: [],
  removedTagsCount: null,
};

const programmableTagsSlice = createSlice({
  name: 'programmableTags',
  initialState,
  reducers: {
    getProgrammableTagRecords: state => {
      state.apiCallsInProgress = addApiCall(state, API_CALLS.GET_PROGRAMMABLE_TAGS).apiCallsInProgress;
    },
    getProgrammableTagRecordsSuccess: (state, action: PayloadAction<IProgrammableTag[]>) => {
      state.programmableTags = action.payload;
      state.apiCallsInProgress = removeApiCall(state, API_CALLS.GET_PROGRAMMABLE_TAGS).apiCallsInProgress;
    },
    getProgrammableTagRecordsFailure: (state, action) => {
      toast.error(`Failed to get programmable tags: ${action.payload}`);
      state.apiCallsInProgress = removeApiCall(state, API_CALLS.GET_PROGRAMMABLE_TAGS).apiCallsInProgress;
    },
    getAppliedTagsNum: state => {
      state.apiCallsInProgress = addApiCall(state, API_CALLS.GET_APPLIED_TAGS_NUM).apiCallsInProgress;
    },
    getAppliedTagsNumSuccess: (state, action) => {
      state.apiCallsInProgress = addApiCall(state, API_CALLS.GET_APPLIED_TAGS_NUM).apiCallsInProgress;
      state.appliedTagsCount = action.payload.applied;
      state.removedTagsCount = action.payload.removed;
    },
    getAppliedTagsNumFailure: (state, action) => {
      toast.error(action.payload);
      state.apiCallsInProgress = addApiCall(state, API_CALLS.GET_APPLIED_TAGS_NUM).apiCallsInProgress;
      state.appliedTagsCount = null;
      state.removedTagsCount = null;
    },
  },
});

function addApiCall(state: IProgrammableTagState, callName: string): IProgrammableTagState {
  const newState = { ...state };
  const isInProgressAlready = newState.apiCallsInProgress.find(x => x.callName === callName) !== undefined;
  const apiCallsInProgress = !isInProgressAlready
    ? [
        ...state.apiCallsInProgress,
        {
          callName,
          retryNumber: 0,
          timeToNextCall: 0,
          hasFailed: false,
        },
      ]
    : newState.apiCallsInProgress;

  return {
    ...newState,
    apiCallsInProgress,
  };
}

function removeApiCall(state: IProgrammableTagState, callName: string): IProgrammableTagState {
  return {
    ...state,
    apiCallsInProgress: state.apiCallsInProgress.filter(x => x.callName !== callName),
  };
}

const { actions, reducer }: any = programmableTagsSlice;
export { actions as programmableTagsActions, reducer as programmableTagsReducer };
